var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralianFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1743_2103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.333 0V50C39.1406 50 50.3334 38.8071 50.3334 25.0004C50.3334 11.192 39.1405 0 25.333 0Z",
    fill: "#252F6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3326 0C11.5259 0 0.333008 11.1924 0.333008 24.9999C0.333008 38.8067 11.5259 49.9996 25.3326 49.9996C39.1402 49.9996 39.1402 0 25.3326 0Z",
    fill: "#273375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4781 38.3231L19.164 36.2215L16.5596 36.6932L15.656 34.1704L14.6739 36.6932L12.0149 36.2215L13.7048 38.2769L11.9502 40.33L14.6245 39.91L15.5265 42.3806L16.509 39.9111L19.2366 40.3986L17.4781 38.3231Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4043 40.1793L38.3604 38.9883L36.8841 39.2555L36.3721 37.8262L35.8155 39.2555L34.3088 38.9883L35.2664 40.1523L34.2725 41.3164L35.7875 41.0781L36.2986 42.4774L36.8552 41.0788L38.401 41.3552L37.4043 40.1793Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4043 13.8633L38.3604 12.672L36.8841 12.9396L36.3721 11.5103L35.8155 12.9396L34.3088 12.672L35.2664 13.8368L34.2725 15.0002L35.7875 14.7622L36.2986 16.1623L36.8552 14.7629L38.401 15.0388L37.4043 13.8633Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5906 20.6708L44.5459 19.4795L43.0704 19.7472L42.5584 18.3179L42.0019 19.7472L40.4943 19.4795L41.4519 20.6445L40.458 21.8081L41.9731 21.5697L42.4842 22.9699L43.0408 21.5705L44.5866 21.8464L43.5906 20.6708Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0563 23.6979L33.0124 22.5069L31.5361 22.7746L31.024 21.3452L30.4675 22.7746L28.9611 22.5069L29.9184 23.671L28.9248 24.835L30.4399 24.597L30.9511 25.996L31.5076 24.5979L33.0535 24.8738L32.0563 23.6979Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.58391 9.68115C5.19155 10.1868 4.81693 10.7059 4.46289 11.2408H7.14278L5.58391 9.68115Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4951 25.0001H20.9034L18.4951 22.5918V25.0001Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5122 4.86963C9.93859 5.29281 9.38642 5.74164 8.85156 6.21094L10.5122 7.87083V4.86963Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10254 25.0003H10.5116V22.5913L8.10254 25.0003Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3344 0C22.962 0 20.6701 0.337466 18.4951 0.955292V7.87108L25.3351 1.0314V0H25.3344Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3352 22.6955V19.2246H21.8643L25.3352 22.6955Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.36549 25.0004L7.14242 19.2246H1.01251C0.573177 21.0795 0.333984 23.0117 0.333984 25.0004H1.36549Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8604 11.2401H25.3336V7.76758L21.8604 11.2401Z",
    fill: "#29337A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3347 23.4235V22.6944L21.8637 19.2235H25.3347V17.9805H19.8916L25.3347 23.4235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14241 11.2395H4.46253C4.19494 11.645 3.94065 12.0598 3.69629 12.4814H8.96095L5.83614 9.35742C5.75054 9.46403 5.66641 9.57181 5.58312 9.67948L7.14241 11.2395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5113 22.5905V24.9995H11.7536V20.772L7.52637 24.9995H8.10229L10.5113 22.5905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4948 0.954102C18.076 1.07296 17.6623 1.20237 17.2529 1.34171V9.68885L25.3348 1.60739V1.03148L18.4948 7.86989V0.954102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4679 19.2231L10.5117 19.1793L11.7105 17.9805H1.34034C1.22075 18.3906 1.11139 18.8047 1.0127 19.2231H7.14261L1.36568 24.9989H4.69178L10.4679 19.2231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3343 12.482V11.2397H21.8611L25.3343 7.76716V4.44189L17.2939 12.482H25.3343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5111 7.87056L8.8505 6.21067C8.26159 6.72822 7.69623 7.27289 7.1582 7.84375L10.5111 11.1967L10.5467 11.233L11.7534 12.4397V4.01318C11.3311 4.28753 10.9154 4.57053 10.5115 4.86894V7.87056H10.5111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4952 22.5915L20.9035 24.9998H24.0765L17.2529 18.1768V24.9998H18.4952V22.5915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1329 19.2241L19.891 17.9814H25.334V12.4827H17.2936L17.2522 12.525V12.4827H17.2936L25.334 4.44309V1.60804L17.2517 9.68992V1.34277C15.2982 2.01032 13.4547 2.91104 11.7531 4.01432V12.4404L11.7961 12.4826H11.7531V12.4404L10.5463 11.2338L10.5534 11.2409H10.5112V11.1978L7.15826 7.84488C6.69803 8.33203 6.25712 8.83649 5.83668 9.3591L8.96139 12.4831H3.69683C2.70206 14.1978 1.90669 16.0404 1.33984 17.9817H11.71L11.7531 17.9379V17.9817H11.71L10.5112 19.1807V19.2245H10.4674L4.69118 24.9999H7.52623L11.7535 20.7723V24.9999H17.2522V18.1768L24.0753 24.9999H25.0136C25.1205 24.8882 25.2295 24.7773 25.3345 24.6625V23.4241L21.1329 19.2241Z",
    fill: "#D32030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.251 9.68979L25.3333 1.60791L17.251 9.68979Z",
    fill: "#D32030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5116 19.2239V19.1797L10.4678 19.2239H10.5116Z",
    fill: "#D32030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7524 17.937L11.709 17.9808H11.7524V17.937Z",
    fill: "#D32030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.251 12.5251L17.2929 12.4829H17.251V12.5251Z",
    fill: "#D32030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5117 11.2407H10.5544L10.5473 11.2341L10.5117 11.1978V11.2407Z",
    fill: "#D32030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7959 12.4826L11.7529 12.4399V12.4826H11.7959Z",
    fill: "#D32030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1743_2103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.333008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralianFlag);
export default __webpack_public_path__ + "static/media/Australian-flag.3d2832b43278995a6a8d1a8e85b120a3.svg";
export { ForwardRef as ReactComponent };